module.exports = __webpack_public_path__ + "static/media/branch-detail-1800.999cac5b.webp";